<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>Programs, Activities and Projects </span>

          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-card>
            <v-row>
              <v-col cols="8" class="pa-5">
                <div class="text-body-1">
                  <strong>
                    Goal {{ goalOutcome ? goalOutcome.goalNo : "" }}
                    <b> / </b>Strategic Outcome
                    {{ goalOutcome ? goalOutcome.stratNo : ""
                    }}<b> / </b>Strategy {{ strategyCode }}:</strong
                  >
                  <div style="text-indent: 30px;">
                    {{ data ? data.description : "" }}
                  </div>
                </div>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="2" class="d-flex justify-end mt-2 mr-2">
                <v-btn
                  @click="AddFunction()"
                  class="white--text rounded-lg"
                  color="#519043"
                >
                  Add
                </v-btn>
              </v-col>
              <v-col cols="12" class=" pt-2 px-4">
                <v-data-table
                  :headers="headers"
                  :items="dataItem"
                  :items-per-page="10"
                  single-expand
                  :expanded.sync="expanded"
                  show-expand
                >
                  <template
                    v-slot:item.data-table-expand="{ item, expand, isExpanded }"
                  >
                    <td v-if="item.multiSDP.length > 0" class="text-start">
                      <v-btn
                        icon
                        @click="expand(!isExpanded)"
                        class="v-data-table__expand-icon"
                        :class="{
                          'v-data-table__expand-icon--active': isExpanded,
                        }"
                      >
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </td>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pt-4 pb-8">
                      <div class="text-body-1 my-4 ml-1 font-weight-bold">
                        Added Specifics for {{ item.code }}
                      </div>
                      <v-data-table
                        :headers="expandedHeaders"
                        :items="item.multiSDP"
                        :items-per-page="20"
                        hide-default-footer
                      >
                        <template v-slot:[`item.def_specs`]="{ item }">
                          <div class="preserve-whitespace text-justify">
                            {{ item.def_specs }}
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                          <v-btn
                            x-small
                            @click="edit(item)"
                            outlined
                            color="blue"
                            >Update</v-btn
                          ></template
                        >
                      </v-data-table>
                    </td>
                  </template>
                  <template v-slot:[`item.kpi`]="{ item }">
                    <div>
                      <b>{{ item.code }}:</b>
                      <span class=" text-justify">
                        {{ item.indicators }}
                      </span>
                    </div>
                  </template>

                  <template v-slot:[`item.def_specs`]="{ item }">
                    <div class="preserve-whitespace  text-justify">
                      {{ item.def_specs }}
                    </div>
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      block
                      x-small
                      @click="edit(item)"
                      outlined
                      class="my-1"
                      color="blue"
                      >Update</v-btn
                    ><v-btn
                      v-if="!item.hasSameCode"
                      x-small
                      @click="upsert(item)"
                      class="my-1"
                      block
                      outlined
                      color="green"
                      >Add New Specifics</v-btn
                    >
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>

          <v-btn color="red" outlined @click="closeD()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn>

          <!-- <v-btn color="#519043" class="white--text" @click="submitTarget()">
            <v-icon>mdi-check-circle</v-icon>
            Submit
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
            Are you sure you want to proceed?
          </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()">
            Close
          </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmDelete()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmSubmitDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to submit this
              <b>Targets for Approval</b>?<br />
              <!-- Please note that
                <b>this action is irreversible.</b> -->
            </p>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <AddPAP :data="targetData" :action="action" />
    <ViewStratPlanTargets :data="viewTargetData" :action="action" />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    AddPAP: () => import("../StrategicPlanning/AddPAP.vue"),
    ViewStratPlanTargets: () =>
      import("../StrategicPlanning/ViewLinkedStratPlanOffices.vue"),
  },
  props: {
    data: null,
    goalOutcome: null,
    strategyCode: null,
    goalID: null,
  },
  data() {
    return {
      remarksData: [],
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      viewTargetData: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      dialog: false,
      targetData: null,
      isSubmitted: null,
      strategic_outcomeID: null,
      strat_planID: null,
      isSubmitLoading: false,
      id: null,
      dataItem: [],
      isButtonLoading: false,
      goalData: null,
      headers: [
        {
          text: "Key Performance Indicators",
          value: "kpi",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Definition and Specifics",
          value: "def_specs",
          align: "start",
          width: 500,
          valign: "start",
          sortable: false,
        },
        {
          text: "Baseline",
          value: "baseline",
          align: "center",
          width: 200,
          valign: "center",
          sortable: false,
        },

        {
          text: "SDP Target",
          value: "sdp_target",
          align: "center",
          width: 200,
          valign: "center",
          sortable: false,
        },

        {
          text: "Action",
          value: "action",
          align: "center",
          valign: "center",
          width: 50,
        },
      ],
      expandedHeaders: [
        {
          text: "Definition and Specifics",
          value: "def_specs",
          align: "start",
          valign: "start",
          width: 400,
          sortable: false,
        },
        {
          text: "Baseline",
          value: "baseline",
          align: "center",
          width: 200,
          valign: "center",
          sortable: false,
        },

        {
          text: "SDP Target",
          value: "sdp_target",
          align: "center",
          width: 200,
          valign: "center",
          sortable: false,
        },

        {
          text: "Action",
          value: "action",
          align: "center",
          valign: "center",
          width: 50,
        },
      ],
      expanded: [],
      singleExpand: false,
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("VIEWPAP", data);
        // this.id = data.id;
        this.goalID = data.goalID;
        this.strat_planID = data.strat_planID;
        this.strategic_outcomeID = data.strategic_outcomeID;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeStratPlanTargets", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeAddPAP");
  },

  methods: {
    initialize() {
      this.getGoal();
      if (this.goalID && this.strategic_outcomeID && this.data.id) {
        this.axiosCall(
          "/pap/getPAPByGoalStratOutcomeStrategy/" +
            this.goalID +
            "/" +
            this.strategic_outcomeID +
            "/" +
            this.data.id,
          "GET"
        ).then((res) => {
          if (res) {
            console.log("PAP", res.data);
            this.dataItem = res.data;
          }
        });
      }

      this.loading = true;
      // this.dataItem = [];
    },

    closeD() {
      this.eventHub.$emit("closeViewPAP", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },
    View(item) {
      console.log(item);
      this.viewTargetData = item;
      this.action = "View";
    },

    edit(item) {
      Object.assign(item, {
        strat_planID: this.strat_planID,
      });
      this.targetData = item;
      this.action = "Update";
    },

    upsert(item) {
      Object.assign(item, {
        strat_planID: this.strat_planID,
      });
      this.targetData = item;
      this.action = "Upsert";
    },

    AddFunction() {
      this.targetData = {
        id: null,
        strat_planID: this.strat_planID,
        strategyID: this.data.id,
        strategicOutcomeID: this.data.strategic_outcomeID,
        goalID: this.data.goalID,
        strategyCode: this.strategyCode,
        goalOrderID: this.goalData.strategic_planning_vp_goal_roleID,
      };
      this.action = "Add";
    },

    getGoal() {
      this.loading = true;
      if (this.goalID) {
        this.axiosCall(
          "/strategic-planning-goal/getGoalByGoalID/" + this.goalID,
          "GET"
        ).then((res) => {
          if (res) {
            this.goalData = res.data;
          }
        });
      }
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    confirmDelete() {
      this.isButtonLoading = true;
      console.log(this.itemToDelete.id);
      this.axiosCall(
        "/strategic-planning/deleteTarget/" + this.itemToDelete.id,
        "DELETE"
      ).then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
          this.itemToDelete = null;
          this.confirmDialog = false;

          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
        }
      });
    },
  },
};
</script>
<style scoped>
.preserve-whitespace {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
